import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 20px;
`

export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const ExtraSpecsWrapper = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: ${props => props.theme.colors.background};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.border};
  max-width: 545px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: ${props => props.theme.colors.text};
    margin-bottom: 15px;
  }
`

export const ExtraSpecItem = styled.div`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid ${props => props.theme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  .key {
    font-weight: 500;
    color: ${props => props.theme.colors.textSecondary};
    min-width: 200px;
  }

  .value {
    color: ${props => props.theme.colors.text};
    word-break: break-all;
  }
`
